import React from 'react';
import { useTranslation } from 'react-i18next';

import StatusColorsBlock from './StatusColorsBlock';

import sanitary_condition_red from 'assets/images/vulnerability-icon/vulnerability_sanitary_condition_red.svg';
import technical_condition_red from 'assets/images/vulnerability-icon/vulnerability_technical_condition_red.svg';
import human_factor_red from 'assets/images/vulnerability-icon/vulnerability_human_factor_red.svg';
import { MarkersColors } from 'pages/InteractiveMap/customMarker/constants';

const VulnerabilitiesTab = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h5 className="mb-2">{t('MapLegend.VulnerabilitiesTab.markerExamples')}</h5>
      <div className="d-flex flex-column gap-2 border-bottom mb-2 pb-2">
        <div className="d-flex gap-2 align-items-center">
          <img src={sanitary_condition_red} width={38} height={38} alt="sanitary condition icon" />
          <span className="ml-2 text-dark">{t('MapLegend.VulnerabilitiesTab.sanitaryVulnerability')}</span>
        </div>
        <div className="d-flex gap-2 align-items-center">
          <img src={technical_condition_red} width={38} height={38} alt="technical condition icon" />
          <span className="ml-2 text-dark">{t('MapLegend.VulnerabilitiesTab.technicalVulnerability')}</span>
        </div>
        <div className="d-flex gap-2 align-items-center">
          <img src={human_factor_red} width={38} height={38} alt="human factor icon" />
          <span className="ml-2 text-dark">{t('MapLegend.VulnerabilitiesTab.humanFactorVulnerability')}</span>
        </div>
      </div>
      <div className="d-flex flex-column gap-2 px-3">
        <h5 className="text-center">{t('MapLegend.VulnerabilitiesTab.criticalityAndDeadline')}</h5>
        <div className="d-flex flex-column gap-2">
          <StatusColorsBlock status={MarkersColors.danger} description={t('MapLegend.VulnerabilitiesTab.critical')} />
          <StatusColorsBlock status={MarkersColors.medium} description={t('MapLegend.VulnerabilitiesTab.high')} />
          <StatusColorsBlock status={MarkersColors.warning} description={t('MapLegend.VulnerabilitiesTab.medium')} />
          <StatusColorsBlock status={MarkersColors.dark} description={t('MapLegend.VulnerabilitiesTab.low')} />
        </div>
      </div>
    </div>
  );
};

export default VulnerabilitiesTab;
